import { render, staticRenderFns } from "./Revision_view.vue?vue&type=template&id=48e4e965"
import script from "./Revision_view.vue?vue&type=script&lang=js"
export * from "./Revision_view.vue?vue&type=script&lang=js"
import style0 from "./Revision_view.vue?vue&type=style&index=0&id=48e4e965&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports